import { render, staticRenderFns } from "./PromotionBannerSets.vue?vue&type=template&id=c66c92fc&scoped=true&"
import script from "./PromotionBannerSets.vue?vue&type=script&lang=js&"
export * from "./PromotionBannerSets.vue?vue&type=script&lang=js&"
import style0 from "./PromotionBannerSets.vue?vue&type=style&index=0&id=c66c92fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66c92fc",
  null
  
)

export default component.exports